const routes = [
  {
    path: "",
    name: "overview",
    component: () =>
      import(
        /* webpackChunkName: "Dashboard" */ "@/view/dashboard/overview/Dashboard.vue"
      ),
    props: true,
  },
  {
    path: "/help",
    name: "help",
    component: () =>
      import(
        /* webpackChunkName: "Dashboard" */ "@/view/dashboard/Help.vue"
      ),
    props: true,
  },
  {
    path: "/Warning",
    name: "Warning",
    component: () =>
      import(
        /* webpackChunkName: "Dashboard" */ "@/view/dashboard/Warning.vue"
      ),
    props: true,
  },
];

export default routes;
